<template>
	<router-view></router-view>
</template>

<script>
	export default {
		name: 'minibar',
	};
</script>



// WEBPACK FOOTER //
// Minibar.vue?59d7473a